import axiosInstance from "./axios";
import {
  Company,
  CreateCompanyBody,
  GrantPermissionBody,
  UpdateCompanyPayload,
} from "./models/companies.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchCompany = async (
  bearerToken,
  companyId
): Promise<Company> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Companies/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch company:", error);
    throw error;
  }
};

export const fetchCompanies = async (
  bearerToken: string
): Promise<Company[]> => {
  try {
    const response = await axiosInstance.get(`${apiUrl}/Companies`, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Failed to fetch companies:", error);
    throw error;
  }
};

export const adminFetchCompanies = async (
  bearerToken: string,
  includeOrganizations?: boolean
): Promise<Company[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Admin/companies${includeOrganizations ? "?omitRelations=false" : ""}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to fetch companies:", error);
    throw error;
  }
};

export const adminFetchCompanyById = async (
  bearerToken: string,
  companyId: number
): Promise<Company> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Admin/companies/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch company by ID:", error);
    throw error;
  }
};

export const createCompany = async (
  bearerToken: string,
  payload: CreateCompanyBody
): Promise<Company> => {
  try {
    const response = await axiosInstance.post(`${apiUrl}/Companies`, payload, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to create company:", error);
    throw error;
  }
};

export const adminUpdateCompany = async (
  bearerToken: string,
  payload: UpdateCompanyPayload
): Promise<Company> => {
  try {
    const response = await axiosInstance.patch(
      `${apiUrl}/Admin/companies`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update company:", error);
    throw error;
  }
};

export const updateCompany = async (
  bearerToken: string,
  payload: UpdateCompanyPayload
): Promise<Company> => {
  try {
    const response = await axiosInstance.put(
      `${apiUrl}/Companies/${payload.id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update company:", error);
    throw error;
  }
};

export const grantCompanyPermissionToUser = async (
  bearerToken: string,
  payload: GrantPermissionBody
): Promise<void> => {
  try {
    await axiosInstance.post(`${apiUrl}/Companies/grantPermissions`, payload, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
  } catch (error) {
    console.error("Failed to grant company permission to user:", error);
    throw error;
  }
};
